<div class="customise-message" [ngClass]="{ 'expanded': expanded }">
  <button type="button" class="customise-message-header" [attr.id]="idPrefix + '-btn'" [attr.aria-expanded]="expanded" (click)="toggle()">
    <span class="customise-message-title">
      <i class="ri-pencil-line me-2 align-middle"></i>{{ title }}

      @if(warning() != '') {
        <span class="customise-message-warning">{{ warning() }}</span>
      }
    </span>

    <i class="customise-message-chevron" [ngClass]="expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
  </button>

  @if(expanded) {
    <div class="customise-message-body">
      <div class="customise-message-toolbar">
        <span class="customise-message-label">{{ label }}</span>

        <span class="customise-message-actions">
          @if(canEdit) {
            <span class="customise-message-inserts">Inserts</span>

            @for (replacement of replacements; track replacement.id) {
              <button type="button" class="customise-message-chip" (click)="insertReplacement(replacement.placeHolder ?? '')">{{ replacement.placeHolder }}</button>
            }

            @if(defaultText != '') {
              <a href="javascript:void(0);" class="customise-message-reset" [attr.id]="idPrefix + 'reset-btn'" (click)="resetToDefault()">Reset to default</a>
            }
          }
        </span>
      </div>

      <textarea
        #messageTextArea
        autocomplete="off"
        class="form-control resize-none"
        data-lpignore="true"
        [attr.id]="idPrefix + '-field'"
        [ngClass]="{ 'is-invalid': !isValid() }"
        [readonly]="!canEdit"
        [rows]="rows"
        [value]="value"
        (input)="onTextChanged($event)"
      ></textarea>

      @if(invalidPlaceHolders() != '') {
        <div class="customise-message-error">Unknown system value(s) found - {{ invalidPlaceHolders() }}</div>
      } @else if(text().trim() == '') {
        <div class="customise-message-error">{{ requiredText }}</div>
      }

      <div class="customise-message-footer">
        <span>{{ characters }} characters</span>

        @if(canEdit) {
          <span>{{ footerText }}</span>
        } @else {
          <span>You do not have permission to edit this message</span>
        }
      </div>
    </div>
  }
</div>
